import { useEffect, useState } from "react";
import * as ReactBootStrap from "react-bootstrap";

function GST() {
  const [gstin, setGstin] = useState();
  const [dates, setDates] = useState();
  const [loading , setLoading] = useState(false);

  useEffect(() => {
    console.log("thh", dates);
  }, [dates]);
  useEffect(() => {
    console.log('gstin', gstin);
  }, [gstin]);

  const handleChange = (e) => {
    setGstin(e.target.value);
  };


  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true to show the spinner

    console.log(gstin);
    await fetch(
      `https://i889jdzbl2.execute-api.ap-south-1.amazonaws.com/default/GST_API_Prod_M_India?gstin=${gstin}`,
      {
        method: "POST",
        headers: {
          "x-api-key": "gE4wOXFLxR3C1uG1vnv3d2CQIs9M5NcO9pMxJjlA",
          'authorizationToken': "WWEP5NFsveuW63y3"
        }
      }
    )
    .then((res) => res.json())
      
    .then((data) => {
      console.log(data);
      setDates(data);
      setLoading(true);

      // setGstin(data);
    })
    .catch((error) =>  console.log(error))
    .finally(() => setLoading(false)); 
  };

  return (
    <div>
   <div  class="container containerBoreder " id="pan">
    <h2 class="pageTitle"> GST Check</h2>
    <div class="row">
        <div class="col-4">
        
          <input
            placeholder="Your GST PAN number"
            value={gstin}
            onChange={handleChange}
          />
        </div>
        {loading ? <ReactBootStrap.Spinner animation="border" /> : (
        <div class="col-4">
          <button class="btn btn-primary" type="submit" onClick={onSubmit}>
            Submit
          </button>
          <div>{JSON.stringify(dates)}</div>
        </div>
      )}
        </div>
        </div>
    
      <br />
      
     
    </div>
  );
}

export default GST;